import React, { Component, Fragment } from "react";
import ReactGA from "react-ga";
import { Translate as T, I18n } from "react-redux-i18n";
import styles from "./Settings.css";
import Dialog from "../Dialog/Dialog";
import Scrollable from "../Scrollable/Scrollable";

export default class Settings extends Component {
  render = () => {
    const { authenticated, show, user, lang, mute } = this.props;

    return (
      <div className={`${styles.settings} ${show && styles.show}`}>
        <Dialog
          onClose={this.handleCloseClick}
          heading={I18n.t("settings.heading")}
        >
          <Scrollable className={styles.wrapper}>
            <nav className={styles.nav}>
              <button
                className={`${styles.item} ${styles.secret}`}
                onClick={this.handleSecretClick}
              >
                <T value={"settings.secret"} />
              </button>
              <button
                className={`${styles.item} ${styles.print}`}
                onClick={this.handlePrintClick}
              >
                <T value={"settings.print"} />
              </button>
              <button
                className={`${styles.item} ${styles.language}`}
                onClick={this.handleLanguageClick}
              >
                <T value={"settings.language"} />
                <span className={styles.label}>{lang}</span>
              </button>
              {mute ? (
                <button
                  className={`${styles.item} ${styles.soundOff}`}
                  onClick={this.handleSoundOnClick}
                >
                  <T value={"settings.soundOff"} />
                </button>
              ) : (
                <button
                  className={`${styles.item} ${styles.soundOn}`}
                  onClick={this.handleSoundOnClick}
                >
                  <T value={"settings.soundOn"} />
                </button>
              )}
              {authenticated ? (
                <Fragment>
                  <button
                    className={`${styles.item} ${styles.changePlayer}`}
                    onClick={this.handleChangePlayer}
                  >
                    <T value={"settings.changePlayer"} />
                    <span className={styles.label}>{user.activePlayer}</span>
                  </button>
                  <button
                    className={`${styles.item} ${styles.signOut}`}
                    onClick={this.handleSignOutClick}
                  >
                    <T value={"settings.signOut"} />
                    <span className={styles.label}>{user.email}</span>
                  </button>
                </Fragment>
              ) : (
                <Fragment>
                  <button
                    className={`${styles.item} ${styles.signUp}`}
                    onClick={this.handleSignInClick}
                  >
                    <T value={"settings.signUp"} />
                  </button>
                  <button
                    className={`${styles.item} ${styles.signIn}`}
                    onClick={this.handleSignInClick}
                  >
                    <T value={"settings.signIn"} />
                  </button>
                </Fragment>
              )}
              <button
                className={`${styles.item} ${styles.about}`}
                onClick={this.handleAboutClick}
              >
                <T value={"settings.about"} />
              </button>
            </nav>
          </Scrollable>
        </Dialog>
      </div>
    );
  };

  handleCloseClick = () => this.props.hideSettings();

  handlePrintClick = () => {
    window.print();

    ReactGA.event({
      category: "Tools",
      action: "Print"
    });
  };

  handleSecretClick = () => this.props.showSecret();

  handleLanguageClick = () => this.props.showLanguages();

  handleSoundOnClick = () => this.props.toggleMute();

  handleSignInClick = () => this.props.showLogin();

  handleChangePlayer = () => this.props.showPlayers();

  handleSignOutClick = () => this.props.signOut();

  handleAboutClick = () => this.props.showAbout();
}



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js